export default __webpack_public_path__ + "arrow-right.svg";